<template>
<div id="tag" v-if="id">
  <h2>Tag '{{ name }}'</h2>

  <tag-nav></tag-nav>

  <table class="table">
    <tbody>
      <tr>
        <td>
          Name
        </td>
        <td>
          {{ name }}
        </td>
      </tr>
      <tr>
        <td>
          Description
        </td>
        <td>
          {{ description || 'n/a' }}
        </td>
      </tr>
      <tr>
        <td>
          Slug
        </td>
        <td>
          {{ slug }}
        </td>
      </tr>
      <tr>
        <td>
          Type
        </td>
        <td>
          {{ tagType || 'n/a' }}
        </td>
      </tr>
      <tr>
        <td>
          Visible to all users?
        </td>
        <td>
          {{ visible }}
        </td>
      </tr>
    </tbody>
    <tag-timestamps></tag-timestamps>
  </table>

  <button
    class="btn btn-danger btn-block"
    v-on:click.prevent="showByTag"
  >
    Show Tagged Items
    <vue-spinner
      size="small"
      v-if="loading"
    ></vue-spinner>
  </button>

  <button
    class="btn btn-danger btn-block"
    v-on:click.prevent="hideByTag"
  >
    Hide Tagged Items
    <vue-spinner
      size="small"
      v-if="loading"
    ></vue-spinner>
  </button>

  <button
    class="btn btn-danger btn-block"
    v-on:click.prevent="deleteTag"
  >
    Delete Tag
    <vue-spinner
      size="small"
      v-if="loading"
    ></vue-spinner>
  </button>
</div>
</template>

<script>
import VueSpinner from 'vue-simple-spinner'

import TagNav from '@/components/TagNav'
import TagTimestamps from '@/components/TimestampRows'

import FlashStore from '@/stores/FlashStore'
import TagStore from '@/stores/TagStore'

export default {
  data () {
    let state = TagStore.state
    state.loading = false

    return state
  },

  computed: {
    tagUrl () {
      return '/tags/' + this.tagId
    }
  },

  components: {
    'tag-nav': TagNav,
    'tag-timestamps': TagTimestamps,
    'vue-spinner': VueSpinner
  },

  props: {
    tagId: {
      type: [ Number, String ],
      default: undefined
    }
  },

  created () {
    this.get()
  },

  methods: {
    get () {
      this.apiGet(this.tagUrl, TagStore, true)
    },

    showByTag () {
      if (confirm(
        'Are you sure you want to activate all tagged items? This will make all tagged puzzles and purchasable items public.'
      )) {
        this.loading = true

        this.$http.post(
          this.apiUrl(
            this.tagUrl + '/show_tagged_items', true
          )
        ).then(() => {
          FlashStore.result('Tagged items toggled to be publicly visible.')
        }).catch(this.$root.processErrors).finally(() => {
          this.loading = false
        })
      }
    },

    hideByTag () {
      if (confirm(
        'Are you sure you want to deactivate all tagged items? This will hide all tagged puzzles and purchasable items.'
      )) {
        this.loading = true

        this.$http.delete(
          this.apiUrl(
            this.tagUrl + '/hide_tagged_items', true
          )
        ).then(() => {
          FlashStore.result('Tagged items hidden.')
        }).catch(this.$root.processErrors).finally(() => {
          this.loading = false
        })
      }
    },

    deleteTag () {
      if (confirm(
        'Are you sure you want to delete this tag? This action cannot be undone.'
      )) {
        this.loading = true

        this.$http.delete(
          this.apiUrl('/tags/' + this.tagId, true)
        ).then(() => {
          this.loading = false

          this.$router.push({
            'name': 'tags'
          })

          FlashStore.result('Tag deleted.')
        }, (resp) => {
          this.loading = false

          this.processErrors(resp)
        })
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Tag.vue